import { useIntl } from 'react-intl';

import type { TranslationKey } from '../models';

export const useTranslations = () => {
  const { formatMessage } = useIntl();

  const translate = (id: TranslationKey, ...rest: unknown[]) => {
    const params = Object.fromEntries(rest.map((cur, index) => [index, String(cur ?? '')]));

    return formatMessage({ id }, params);
  };

  return {
    formatMessage,
    translate,
  };
};
